import { useApplyColorModeContrast } from "./useColorModeContrast";

/**
 * Parent hook for all display mode preferences.
 * Called by DBBL's LibraryProvider (see `providers/displayModesEffects.tsx`).
 * Resolves and applies all accessibility display modes to the DOM.
 */
export const useDisplayModes = () => {
  const colorModeContrast = useApplyColorModeContrast();

  return {
    colorModeContrast,
    // future: colorScheme
    // future: colorblindMode
    // future: dyslexiaMode
  };
};
